import { AdminShipment } from "@/model/transportorder/transportOrder"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface AdminUIState {
    selectedTransportOrder?: AdminShipment
}

export const initialAdminUIState: AdminUIState = {
    selectedTransportOrder: undefined,
}

export const adminUiSlice = createSlice({
    name: "adminUi",
    initialState: initialAdminUIState,
    reducers: {
        setSelectedTransportOrder: (state, action: PayloadAction<AdminShipment | undefined>) => {
            state.selectedTransportOrder = action.payload
        },
    }
})
